export const TEXT = {
  HOME: {id: 'navigation.bar.home'},
  LOOK_IN: {id: 'shop.menuaccess.main'},
  FRIENDS: {id: 'navigation.bar.raf'},
  PROFILE: {id: 'navigation.bar.profile'},
  RAF_EXP: {id: 'navigation.bar.raf_exp'},
};
